import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SportProvider } from './contexts/SportContext';
import { EventProvider } from './contexts/EventContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import './i18n'; // NEU: Importiere die Sprachkonfiguration

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <Suspense fallback="Loading...">
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <SportProvider>
              <NotificationProvider>
                <ToastProvider>
                  <EventProvider>
                    <App />
                  </EventProvider>
                </ToastProvider>
              </NotificationProvider>
            </SportProvider>
          </AuthProvider>
        </BrowserRouter>
      </Suspense>
    </React.StrictMode>
  </ErrorBoundary>
);

// Service Worker Registrierung
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        if (process.env.NODE_ENV !== 'production') console.log('SW registered:', registration);
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') console.log('SW registration failed:', error);
      });
  });
}
